<template>
  <div class="milestone-screen">
    <div v-if="step == 0" class="milestone-screen__slide">

          
      <div class="grid-container">
        <div class="milestone-screen__heading">
          <div class="milestone-screen__text-container">
            <h1>
              Leistungsvereinbarung (LV)
            </h1>
            <h2>
              Meilenstein
            </h2>
          </div>
        </div>

        <div class="milestone-screen__text-part-1">
          <div class="milestone-screen__text-container">
            <p>
              Super, ihr habt den Meilenstein <strong>Leistungsvereinbarung</strong> erreicht! <br>
              An diesem Meilenstein werden alle Aktivitäten der vorangegangenen Phase in der Leistungsvereinbarung zusammengefasst. 
              Diese bildet nun euren jeweiligen Handlungsrahmen für die folgenden drei Phasen.
            </p>
            <p>
              Auf Basis der Leistungsvereinbarung werden in der Phase <strong>Datenerzeugung</strong> die vereinbarten Datenumfänge erzeugt und bis zum Meilenstein <strong>Datenlieferung</strong> bereitgestellt.
              Solltet ihr euren Datenumfang noch nicht vollständig vereinbart haben, könnt ihr dies zu Beginn der nächsten Phase noch nacharbeiten, indem ihr statt einem Spielfeld in der ersten Spielrunde die Option <strong>Nacharbeit</strong> wählt.
            </p>
            <p>
              <strong>Achtung:</strong> Auf dem Dashboard hat sich etwas verändert! Ihr befindet euch nun auf dem Dashboard für die 
              zweite Phase <strong>Datenerzeugung</strong>. Passend dazu seht ihr im linken Bereich des Dashboards jeweils eure in der 
              ersten Phase vereinbarten Daten. Im rechten Bereich findet ihr (noch) leere Container. In diesen 
              sammelt ihr jeweils eure Teile sobald ihr ein passendes Spielfeld betretet. 
            </p>
          </div>

        </div>

        <div class="milestone-screen__text-part-2-image">
          <div class="milestone-screen__text-container">
            <img class="milestone-screen__image" :src="images.LVDashboard" />
          </div>
        </div>

        <div class="milestone-screen__text-part-2">
          <div class="milestone-screen__icon-container">
            <svg class="milestone-screen__innovation-icon" xmlns="http://www.w3.org/2000/svg" width="81.106" height="118.569" viewBox="0 0 81.106 118.569">
              <title>06_Innovation</title>
              <path d="M40.505,0A40.525,40.525,0,0,0,0,40.5c0,11.128,3.616,17.57,6.837,23.131,2.636,4.587,4.679,8.2,5.464,15.223a14.457,14.457,0,0,0,1.072,4.491,12.917,12.917,0,0,0-.779,4.3,10.922,10.922,0,0,0,.975,4.681A12.572,12.572,0,0,0,12.594,97a12.214,12.214,0,0,0,7.027,11.029,15.36,15.36,0,0,0,14.636,10.538H46.844a15.453,15.453,0,0,0,14.641-10.538A12.143,12.143,0,0,0,68.512,97a10.876,10.876,0,0,0-.976-4.685,11.954,11.954,0,0,0,.2-8.976A10.2,10.2,0,0,0,68.8,78.85c.783-7.027,2.837-10.636,5.469-15.223,3.22-5.661,6.837-12,6.837-23.227A40.66,40.66,0,0,0,40.505,0ZM56.311,102.355a9.066,9.066,0,0,1-2.764,3.219c-2.12,2.051-7.116,3.486-12.942,3.486s-10.822-1.433-12.942-3.484a8.529,8.529,0,0,1-2.08-2.23,16.046,16.046,0,0,1-1.146-2.212H56.782A11.1,11.1,0,0,1,56.311,102.355Zm1.831-13.271a2.338,2.338,0,0,1-1.961,1.11H25.08a2.362,2.362,0,0,1-1.694-.715A4.494,4.494,0,0,1,21.723,85.9a4.033,4.033,0,0,1,3.708-4.292H55.672a4.033,4.033,0,0,1,3.71,4.292A4.577,4.577,0,0,1,58.142,89.084Zm6.564-30.823A51.688,51.688,0,0,0,59.232,70.7H21.768A51.584,51.584,0,0,0,16.3,58.354c-2.924-5.073-5.362-9.466-5.362-17.759a29.57,29.57,0,0,1,59.139-.1C70.074,48.791,67.536,53.188,64.706,58.261Z"/>
            </svg>
          </div>
          <div class="milestone-screen__text-container">
            <p>
              Über die Prozess-Darstellung oberhalb des Dashboards habt ihr die Möglichkeit zwischen allen Spielphasen zu wechseln. 
              Möchtet ihr also noch einmal einen Blick auf eure Leistungsvereinbarungen werfen, müsst ihr nur auf den entsprechenden Pfeil klicken.
            </p>
          </div>
        </div>

        <div class="milestone-screen__text-part-3">
          <div class="milestone-screen__text-container">
            <p>
             Zur Beschaffung aller vereinbarten Daten stehen dir in der nächsten Phase die folgenden <strong>Spielfelder</strong> zur Verfügung:
            </p>
          </div>
        </div>

        <!-- Daten sammeln -->
        <div class="milestone-screen__text-part-4">        
            <div class="milestone-screen__icon-container-field">
              <svg class="milestone-screen__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 91.68 93.15"><defs><clipPath id="ea2b7932-2fc6-456f-9214-52a911442fc0" transform="translate(0.44 0.45)"><path d="M16,2.47A13.69,13.69,0,0,0,2.44,16.28V71.47A13.69,13.69,0,0,0,16,85.28H70.35A13.69,13.69,0,0,0,83.93,71.47V16.28A13.69,13.69,0,0,0,70.35,2.47ZM0,0H90.8V92.25H0V0Z" style="fill:none;clip-rule:evenodd"/></clipPath><clipPath id="ff039dd5-e11a-4bf9-8fb2-e255044b398e" transform="translate(0.44 0.45)"><polygon points="0 92.25 90.8 92.25 90.8 0 0 0 0 92.25 0 92.25" style="fill:none;clip-rule:evenodd"/></clipPath><clipPath id="ec35adaf-d08d-4c07-87cf-c452a7e0a031" transform="translate(0.44 0.45)"><polygon points="24.36 65.7 61.12 65.7 61.12 21.6 24.36 21.6 24.36 65.7 24.36 65.7" style="fill:none"/></clipPath></defs><g id="a85622df-b0f4-4c07-8e45-351565370970" data-name="Ebene 2"><g id="ac0a3b92-b331-4a0f-b44f-0b29eef2e2d3" data-name="Ebene 1"><g style="clip-path:url(#ea2b7932-2fc6-456f-9214-52a911442fc0)"><image width="207" height="207" transform="scale(0.44 0.45)" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANAAAADTCAYAAADwMJ3aAAAACXBIWXMAABkRAAAZEQGQh6VoAAALeklEQVR4Xu2b7XLiSAxF5YRkd9//YXeTCfH+AIVrobbbCAgf51R12QZshyqduerGM4zjaABwGi9LHwCANggEUGCz9IFbYRiGYekz8BiMdzSvGG7lb10QBHmek7Q4b0mwXxMoEWbtMTwusShnj39TqKu3cCKOChFfGwyBnplMGH1tcuwl9RsiXUWgkDZREpXFFzXi69n58HhESXw7No5TkcyuJ9PFBQqJE8dLx35MIwR6XLKU8fHdsf8j1LVS6WJzoBlxXjpGJpRfS7fwOIzJVgX57hiZULuLXajQz55AC+K82kGSjbz2Ku/pZzKBkOdx0aKPKeNjux/fZvaVvLaVcy6eSGcVKJFHU8Ul2ch2I8dRpDmJHGS6f7SgVR7fZvL4+NqPbdj6Z12in2sOw3BWic4m0F6erFWLsrwlWxVLUyi2crRwj0ts3ebSR+X5sx96/GW7unGZnJ80OpdEZYFmUicT5z1s3+T9LH2iPJk4yHS/ZEWcCeTbOYE+99vNfl8lMjsk0k8SmdVbupJADXm0VVNZ/trvqzw+YvuWJQ+t22MTW7lWEkWJVCAfG9n31t+FG+Ra4zAMQ0WikwUK8sR5jovxbjtx/pJ9lcjTp7V40NO2IdP90irc3nZOU+jdzD7sUFdei5/7a3mdbO1AWaKTBdqTtWxRHB9/Wy5PrziI8ly0JIpp9GW7evL2Lasts0NNeUvnlCQ6SSBZMFB5Yur8LUNTKP4LkcljyRaejzHZ6tjarpa+bDrfjgtSZoc600RymU6WaLVAYbUtyhPFUYFa8mSpY2EfnhOvgdb86MV2xa/TB60t3/drxRozCxLZSlYJ1JDHY9Pl+Wc/luTxa7SSBoEgY7BpIr0kI3Y3fl4m0CTl1i5xdwuULBrogkGURwWK8rg0+sV0CxCZq41Yl3FKkAmUzat8brVKom6B9sT0iXMeFcjnPZk8+i8B4sBaYs282E6AoTEUl0X343E3XQJ1zHuyuY+vuM3FKUCFWEN63KoxTZs4vD6/e1NoUaDG7z2+0pGtuMW2zYUjdeBSaD1pl5MxJ5C/N5j1tXKLAu3R9JmTJ1swyNo2gHOTtXUZ2RMN+jR3bOtmmRUoad105S37sRR54LeJaeQiaN1mAvmDp97Kda3KrU0g/SOiQMgDt0KUyNH2LXsoVZOo63ehVswBQAdLCaTtm6eP/3D6HkZMn6XJHMAl8brTkHi1aQLp09z6f4q21tnGNQWa+a8K8Zm3VusGcAuoSKNNn555t6lALlF3G9fTwsUE0vRxmTyZdLma9IHfJluZ66nlOIdvkgoUVt9aLZwO/72H1g1ujayWo0QxCI5qWTqyCUsJFG+oLVx8OJTWDe6BpUBQiRbr+dRFBB3ZkvXijQGujNakJoxKFANB6zqdC80lkMrgF12SB+Ae0FDoreu0jTsSqDH/iX3jRo5JH7gXJkJYLtKrjMVwOGUOFPc16gDugVY4uESxfWvS28LFG3XfAOCGadV2d433JFAWdfHiSAT3QpxuaG3HjiqOI1oC6QnRUr2Bno9IcG+oQFmdL9b02gSKx/oZgHtiCFuVqJU8RytxmUCTE8KIyYM4cM+06jvK06zziUDBLj255yYA90qUJavrtM6XWjgnuyjiwKORJc9snc8tIug2voY88IisDoieBFplJMCdUarpHoFanHxTgBsk67oWWStQvMmqmwE8GmsFAgABgQAKIBBAAQQCKIBAAAUQCKAAAgEUQCCAAggEUACBAAogEEABBAIogEAABRAIoAACARRAIIACCARQAIEACiAQQAEEAiiAQAAFEAigAAIBFEAggAIIBFAAgQAKIBBAAQQCKIBAAAUQCKAAAgEUQCCAAggEUACBAAogEEABBAIogEAABRAIoAACARRAIIACCARQAIEACiAQQAEEAiiAQAAFEAigAAIBFEAggAIIBFAAgQAKIBBAAQQCKIBAAAUQCKAAAgEUQCCAAggEUACBAAogEEABBAIogEAABRAIoAACARRAIIACCARQAIEACiAQQAEEAiiAQAAFEAigAAIBFEAggAIIBFAAgQAKIBBAAQQCKIBAAAUQCKAAAgEUQCCAAggEUACBAAogEEABBAIogEAABRAIoAACARRAIIACCARQAIEACiAQQAEEAiiAQAAFEAigAAIBFEAggAIIBFAAgQAKIBBAAQQCKIBAAAUQCKAAAgEUQCCAAggEUACBAAogEEABBAIogEAABRAIoAACARRAIIACCARQAIEACiAQQAEEAiiwVqAxbAGemrUCKaMhEjwOJ4VDr0B60VU3ALhxSkGwJJBevHQjgDtgdVC0BIonj8kAeERWhcZcAsWLzA2Ae2eprtM6nwg0jmM8cUkc5IF7Zqm2vb6bdd4zB/Ltt4x4cUSCe0Vl+Q7HsbbHfcj8MDcH8g/Gi2YSxXMAbp1Y417Tsb5na7ongfSiW9nvvgnADRHTRcXJ6lvPOWJpEUFvsg0j3gTg3oj1HSVSwVJ6Eug7jJZEiAT3REueWNuzHAkkK3FZAn3ZvECIBLdMq669trW+z55A2Y2+5H2Ae2GurqNEP+fEFTgzs018QWglULyRtneDnK/7ALfCkjxZXZ+cQGbHN/ojI96Q9g1ulblpSazp7npOBUrmQWrs3A3jfAjgt5kTJ9ZyJtBojfbNbDmB9MZRns/9yCTS8wFuhRgGWstZR7WYQnNzICeLu08ze5OxMbNX2wk57IfvA/wW2gnpnEbrWMcfO16Fm6Up0DiO4zD81H/WwqlEmUAsKMBvEqcSWf1+mtmHHeRxgSbTkVb7ZtaXQGbtFNrIcIF8eAo5SATXIs55zPLk+bCDQJ92aOG60sdsQaBGCn3Z7mav+5EJpLIgEVyTbMHAbCrPh5n9Z1N5VqePWX8CmR0WEgabStRKHwWJ4Bpk8rhA3qJ9yFCJVi1fO4sChRRSiV7sWBydA0Xiih8iwbkYZRvl+bN/T5PHh4uULl8vpY9Zh0BmE4liP/lpffKY7f4o/5yDRFClZ6XNbCrPv3YQKC4edMtj1ilQwFPIbLriNshr+lkfeq9MHGSCXrS4s7ZNf6/82H/uXxkuUmvu083SD6kAMEN3AiUrcr6YEFPIPzQm49uOV+tII+ghpo5vva6y1s3nOGbHCaRL1ye1b2YrBDJLJTLLJfAvFb/cmx0kerXDYgTCwBJZ2+Y15gJk8vy3P0dbN1158999vm2lPGYrBRL8jzfb/QHZez62st3a9MfXbAFi2F8DqcCJiZPVWPYjqQtjNl11K899nNUC7VPIizxK1IpW/4JfZvZuuyTa2iGJsqcXskUJeC7GsI1djf+jnD3bpmljdvzEwdEzb2vTx+wEgcwWJTLLv6AOfYbOk0ifpVOJWgIh1uPQKlwVSOXRlk1X3OLjOToH8s8ctW1mp8ljdqJAZrMSZfMf/Vfi3Q4ppA+iZmkUBUKaxyeb68RaasmTDf8hNT5pXZbHrCCQWVOi+KU1gfTLxhRqPRLESt3jkxXwGIbOpb0F80RxUXT7Je+bTcU5izxmRYHMUom8sFUg/9JvtvtSLk4m0FwKIc3jo21blj7ZlOCPDD/eyjCbinMWeczMhjNc44e9SF7k8Rk5ffB0k4xWGxcXFeI+PA5jsvWi1/YrCrRN9jVt/Fqj2fql6jnOKpDZj0Rm0/SIIunYhNejeKTP85EJpPMfTSJNGv3MJG18e055zC4gkNmRRL6NIqlQ2esxfRDoedDCVxGiIHFeo7LFNDu7PGYXEshZEClKNdixOL7Va8BzoALEJPJtlOviiRO5qEDOjEhmU5n09Zg6CPQ8aFFGKebGz7mXFse5ikCOiGSWixK3cR+eiyhS3MbXriaOc1WBlIZM2TECPS+ZQEfH15ZG+TWBlCDT5K3G6/A8pAX6m9IoNyHQHDNywYNzK5LMcfMCAdwyukwMACtBIIAC/wOre9HS1t11rgAAAABJRU5ErkJggg=="/></g><g style="clip-path:url(#ff039dd5-e11a-4bf9-8fb2-e255044b398e)"><path d="M2.44,16.28A13.69,13.69,0,0,1,16,2.47H70.35A13.69,13.69,0,0,1,83.93,16.28V71.47A13.69,13.69,0,0,1,70.35,85.28H16A13.69,13.69,0,0,1,2.44,71.47Z" transform="translate(0.44 0.45)" style="fill:#fff;fill-rule:evenodd"/><path d="M2.44,16.28A13.69,13.69,0,0,1,16,2.47H70.35A13.69,13.69,0,0,1,83.93,16.28V71.47A13.69,13.69,0,0,1,70.35,85.28H16A13.69,13.69,0,0,1,2.44,71.47Z" transform="translate(0.44 0.45)" style="fill:none;stroke:#b2b0ad;stroke-linejoin:round;stroke-width:0.45045003294944763px"/><g style="clip-path:url(#ff039dd5-e11a-4bf9-8fb2-e255044b398e)"><g style="clip-path:url(#ff039dd5-e11a-4bf9-8fb2-e255044b398e)"><g style="clip-path:url(#ec35adaf-d08d-4c07-87cf-c452a7e0a031)"><path d="M61.1,43.71C61,43,60.28,41.54,58,41.54s-3,1.46-3.06,2.23V57.09a2.44,2.44,0,0,1-2.44,2.41H33a2.42,2.42,0,0,1-2.44-2.41V43.68c-.09-.79-.86-2.14-3.16-2.14s-3,1.49-3,2.27v17.3A4.59,4.59,0,0,0,29,65.7H56.51a4.59,4.59,0,0,0,4.59-4.59V43.71Z" transform="translate(0.44 0.45)" style="fill:#7d7878"/><path d="M33.66,36.64c0-.21.1-.69,1-.69l4,0,.06-13.3c0-.05,0-.1,0-.15a.83.83,0,0,1,.26-.61,1.3,1.3,0,0,1,1-.31l6.12,0a1,1,0,0,1,1,.85.19.19,0,0,1,0,.08L47,35.73l3.65,0c1,0,1.17.49,1.16.78a1.64,1.64,0,0,1-.53,1c-.23.32-6.6,8.77-7.52,9.69a1.15,1.15,0,0,1-.9.39,1.45,1.45,0,0,1-.94-.49l-7.68-9.46a1.82,1.82,0,0,1-.57-1Z" transform="translate(0.44 0.45)" style="fill:#7d7878"/></g></g></g></g></g></g></svg>
            </div>
            <div class="milestone-screen__text-container-small">
              <p>
                <strong>Daten sammeln</strong><br>
                Auf diesem Feld wählst du eine Kategorie und erhältst eine zufällige Auswahl aller vereinbarten Daten dieser Kategorie.  
              </p>
            </div>  
        </div>

        <!-- Daten aus Datenbank -->
        <div class="milestone-screen__text-part-4">
            <div class="milestone-screen__icon-container-field">
              <svg class="milestone-screen__icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 91.68 93.15"><defs><clipPath id="a2174840-cc93-4c98-9971-c884f993eb33" transform="translate(0.44 0.45)"><path d="M16,2.47A13.69,13.69,0,0,0,2.44,16.28V71.47A13.69,13.69,0,0,0,16,85.28H70.35A13.69,13.69,0,0,0,83.93,71.47V16.28A13.69,13.69,0,0,0,70.35,2.47ZM0,0H90.8V92.25H0V0Z" style="fill:none;clip-rule:evenodd"/></clipPath><clipPath id="bec32d6d-34d0-42d4-bf70-5be20d80f296" transform="translate(0.44 0.45)"><polygon points="0 92.25 90.8 92.25 90.8 0 0 0 0 92.25 0 92.25" style="fill:none;clip-rule:evenodd"/></clipPath><clipPath id="f0220f0f-0a32-44e3-85e2-fe9f635ad1d7" transform="translate(0.44 0.45)"><polygon points="21.26 66.15 66.44 66.15 66.44 21.15 21.26 21.15 21.26 66.15 21.26 66.15" style="fill:none"/></clipPath></defs><g id="b6ea91cf-3e94-4dac-b231-1d6d1a597f06" data-name="Ebene 2"><g id="b29682ab-7d06-47f6-acbf-612e35fccab6" data-name="Ebene 1"><g style="clip-path:url(#a2174840-cc93-4c98-9971-c884f993eb33)"><image width="207" height="207" transform="scale(0.44 0.45)" xlink:href="data:image/png;base64,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"/></g><g style="clip-path:url(#bec32d6d-34d0-42d4-bf70-5be20d80f296)"><path d="M2.44,16.28A13.69,13.69,0,0,1,16,2.47H70.35A13.69,13.69,0,0,1,83.93,16.28V71.47A13.69,13.69,0,0,1,70.35,85.28H16A13.69,13.69,0,0,1,2.44,71.47Z" transform="translate(0.44 0.45)" style="fill:#fff;fill-rule:evenodd"/><path d="M2.44,16.28A13.69,13.69,0,0,1,16,2.47H70.35A13.69,13.69,0,0,1,83.93,16.28V71.47A13.69,13.69,0,0,1,70.35,85.28H16A13.69,13.69,0,0,1,2.44,71.47Z" transform="translate(0.44 0.45)" style="fill:none;stroke:#b2b0ad;stroke-linejoin:round;stroke-width:0.45045003294944763px"/><g style="clip-path:url(#bec32d6d-34d0-42d4-bf70-5be20d80f296)"><g style="clip-path:url(#bec32d6d-34d0-42d4-bf70-5be20d80f296)"><g style="clip-path:url(#f0220f0f-0a32-44e3-85e2-fe9f635ad1d7)"><path d="M61.64,21.2H25.86a4.45,4.45,0,0,0-4.59,4.33,1.69,1.69,0,0,0,0,.23V52.45a5,5,0,0,0,.14,1.22A4.54,4.54,0,0,0,26,57.11q6.44,0,12.88,0c.42,0,.49.12.49.5,0,1.18,0,2.35,0,3.52,0,.38-.1.48-.48.48-2.71,0-5.43,0-8.14,0-.34,0-.44.08-.43.43,0,1.22,0,2.43,0,3.65,0,.34.06.44.42.44,2.18,0,4.35,0,6.53,0H56.88c.39,0,.55,0,.53-.5q0-1.76,0-3.51c0-.42-.11-.5-.5-.49-2.7,0-5.39,0-8.1,0-.37,0-.45-.11-.45-.46,0-1.19,0-2.38,0-3.56,0-.38.08-.48.47-.48q6.42,0,12.83,0a4.55,4.55,0,0,0,4.77-4.74V26a4.52,4.52,0,0,0-4.79-4.76Zm1.15,30.14a2.3,2.3,0,0,1-2.3,2.31H27.1a2.3,2.3,0,0,1-2.3-2.31v-24A2.3,2.3,0,0,1,27.1,25H60.49a2.3,2.3,0,0,1,2.3,2.31Z" transform="translate(0.44 0.45)" style="fill:#7d7878"/></g></g></g></g></g></g></svg>
            </div>
            <div class="milestone-screen__text-container-small">
              <p>
                <strong>Daten aus Datenbank</strong><br>
                Auf diesem Feld kannst du bis zu fünf spezifische Daten einer vereinbarten Kategorie aus der Datenbank auswählen.
              </p>
          </div>
        </div>

          <button
            class="button milestone-screen__button"
            :disabled="playerIsReady"
            @click="moves.markAsReady(myself.id)"
          >
            <span v-if="playerIsReady">
              Warte auf {{ currentMove.waitingOnPlayers.length }} Mitspieler<loading-icon></loading-icon>
            </span>
            <span v-else>Weiter mit Phase 2</span>
          </button>
      </div>
      <game-footer></game-footer>
    </div>
  </div>
</template>

<script>

import GameComponentMixin from "../GameComponentMixin.js";
import LoadingIcon from "../../ui/LoadingIcon.vue";

import GameFooter from "../../ui/GameFooter.vue";

//Images
import LVDashboard from "../../../assets/milestoneimages/LV-Dashboard.png";

export default {
  mixins: [GameComponentMixin],
  components: {
    LoadingIcon,
    GameFooter
  },
  data() {
    return {
      images: {
        LVDashboard
      },

      step: 0
    }
  },
  mounted() {
    console.log(this.moves);
  },
  methods: {
    incrementStep() {
      this.step++;
    }
  },
  computed: {
    playerIsReady() {
      return !this.currentMove.waitingOnPlayers.includes(this.myself.id);
    }
  }
}
</script>

<style lang="scss">
.milestone-screen {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: #F6F6F6;
  color: $color-text;

  h1 {
    margin-top: 0;
    
  }

  h2 {
    color: $color-headline-light;
    margin-bottom: 0;
  }

  p {
    line-height: 1.8;
  }

  .grid-container {
    display:grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: repeat(7, auto);
    margin: 0 10rem;
    column-gap: 0;
    padding-bottom: 1rem;
  }

  &__symbol {
    fill: #FFFFFF;
    stroke: currentColor;
    align-self: start;
  }


  &__text-container {
    padding: 1rem 0;
  }

  &__text-container-small {
    margin-left: 1.5rem;
    float: left;
    vertical-align: middle;

  }

 &__heading {
    grid-column: 1 / 6;
  }

  &__text-part-1 {
    grid-column: 1 / 6;
    font-size: 18px;

  }

  &__text-part-2 {
    grid-column: 3 / 5;
    font-size: 18px;
    padding-left: 2rem;
    display: flex;
  }

  &__text-part-2-image {
    grid-column: 1 / 3;align-self: center;
  
  }

  &__text-part-3 {
    grid-column: 1 / 6;
    font-size: 18px;
    
    
  }

  &__text-part-4{
    grid-column: 1 / 6;
    font-size: 18px;
    display: flex;
    margin-bottom: 2.5rem;
    
  }

  &__icon-container-field {
    float:left;
    align-self: center;

  }

  &__icon-container {
    float:left;

  }

  &__icon {
    height: 6.5rem;
    widows: auto;
    
  }

  &__innovation-icon {
    fill: rgb(255, 224, 47);
    height: 3rem;
    padding-top: 2.3rem;
    
  }

  &__image {
    height: 28rem;
    width: auto;
    
    
  }

  &__button {
    margin-bottom: 2em;
  }

}

</style>